import React, { Component } from 'react';

import ContenedorProcesos from './ContenedorProcesos';

class TableroProcesos extends Component {
    render() {
        const { procesosPorAdministradora, procesosProgramados, fecha } = this.props;

        return (
            <div>
                {this.props.loadingEjecDemanda && <div id="loading" className="loading" />}
                <div className={procesosPorAdministradora.length > 1 ? 'row tableroProcesos procesosScroll' : 'row tableroProcesosSingle procesosScroll'}>
                    {procesosPorAdministradora.map(marca => <ContenedorProcesos fecha={fecha} procesosProgramados={procesosProgramados} mostrarModal={this.props.mostrarModal} variasMarcas={procesosPorAdministradora.length > 1} administradora={marca.marcaId} procesos={marca.ejecuciones} />)}
                </div>
            </div>
        );
    }
}

export default TableroProcesos;